import withModalLargeShow from "../hoc/withModalLargeShow";
import ModalLarge from "../view/components/Modals/ModalLarge";

export default withModalLargeShow(ModalLarge)